import { FormattedMessage } from '@flipster/i18n';
import { css } from '@flipster/styled-system/css';

export const NoData = () => {
  return (
    <p
      className={css({
        textStyle: 'Text/L/Regular',
        color: 'content.default.level-5',
        textAlign: 'center',
        whiteSpace: 'pre-wrap',
      })}
    >
      <FormattedMessage id='Common.r250925.Cant_find_symbol' />
    </p>
  );
};
